import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getAppointmentList = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETAPPOINTMENTLIST, params);
    return data;
};
const getAppointmentDetail = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETAPPOINTMENTDETAIL, params);
    return data;
};
const editAppointment = async (params) => {
    const data = await apiCall("post", apiEndPoints.EDITAPPOINTMENT, params);
    return data;
};
const getvisitorList = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETVISITORLIST, params);
    return data;
};
const addAppointment = async (params) => {
    const data = await apiCall("post", apiEndPoints.ADDAPPOINTMENT, params);
    return data;
};
const getAppointmentListForAdmin = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETAPPOINTMENTLISTFORADMIN, params);
    return data;
};

const checkinAppointment = async(params)=>{
    const data = await apiCall("post", apiEndPoints.CHECKINAPPOINTMENT, params);
    return data;
}

const closeAppointment = async(params)=>{
    const data = await apiCall("post", apiEndPoints.CLOSEAPPOINTMENT, params);
    return data;
}

const allocateClosingManager = async(params)=>{
    const data = await apiCall("post", apiEndPoints.ALLOCATECLOSINGMANAGERS, params);
    return data;
}

const appointmentService = {
    getAppointmentList,
    getAppointmentDetail,
    editAppointment,
    getvisitorList,
    addAppointment,
    getAppointmentListForAdmin,
    checkinAppointment,
    closeAppointment,
    allocateClosingManager
};

export default appointmentService;